import React from "react";
// import Loader from "react-loader-spinner";
import LoaderButton from "../components/LoaderButton";
import Modal from '../components/Modal'
import HttpServices from "../utils/Http.services";
import { imageAddress, translate } from "../utils/useful";


class SearchUsersModal extends React.Component {
    state = {
        data: [],
        selecteds: {}
    }

    componentDidMount() {
        // this.setState({ countries: countriesCode })
        this.initData()


    }

    componentDidUpdate(prevProps) {
        if (prevProps.data != this.props.data) {
            this.initData()
        }
    }

    showModal = () => {
        this.initData()
        this.modal.showModal()
    }

    hideModal = () => {
        this.setState({ selecteds: {}, data: [] })
        this.modal.hideModal()

    }


    initData = () => {
        this.fetchData()
        this.setState({ selecteds: {} }, () => {
            if (Array.isArray(this.props.data)) {
                let selecteds = this.state.selecteds
                this.props.data.forEach(element => {
                    // selecteds[element._id] = { _id: element._id, removed: false, init: true }
                    selecteds[element._id] = element//{ _id: element._id, removed: false, init: true }
                    selecteds[element._id].removed = false
                    selecteds[element._id].init = true

                    if (this.props.disableInitData) {
                        selecteds[element._id].disabled = true
                    }
                });
            }

        })
    }



    fetchData = () => {

        this.setState({ isLoadingData: true })

        HttpServices.request('searchUser', { appletHub: this.props.variables?.appletHub }, (fetchResult, fetchError, fetchStatus) => {
            this.setState({ isLoadingData: false })

            if (fetchError) {
                return
            }
            this.setState({ rawData: fetchResult.info, data: fetchResult.info })

        })
    }



    onDone = () => {
        // this.setState({ isLoadingPost: true })
        let selecteds = this.state.selecteds
        let final = []
        Object.values(selecteds).forEach(element => {
            // if (!element.init) {
            final.push(element)
            // }
        });

        // return


        this.props.onDone(final, 'hub', () => {
            // this.setState({ isLoadingPost: false })
        })
        this.modal.hideModal()
    }


    search(value) {
        // let data = this.state.rawData
        // data = data.filter(e => e.name?.toLowerCase().includes(value.toLowerCase()))
        // this.setState({ data })
    }

    changeSelect = (prop) => {
        if (!this.state.selecteds[prop._id]?.disabled) {
            let selecteds = this.state.selecteds
            if (!selecteds[prop._id] || selecteds[prop._id].removed) {
                selecteds[prop._id] = { _id: prop._id, fullname: prop.fullname, image: prop.image, type: prop.type, username: prop.username }
            } else {
                if (selecteds[prop._id]?.owner && this.props.mainAccess) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.canNotChange', description: "The owner can not be removed from the main access list" })

                    //= { id: prop._id, fullname:prop.fullname,type:prop.type,username:prop.username,uType:'user',removed: true, init: false }
                } else {
                    delete selecteds[prop._id]
                }
            }


            this.setState({ selecteds })
        }
    }

    render() {
        return (

            <Modal ref={el => this.modal = el} maxWidth={400} className={'flexcc'} noScroll={true} modalContentClassName={'h-100'} marginBottom={'5%'}>
                <div className="d-flex h-100 flex-column w-100 scroll-no-scrollbar" style={{ backgroundColor: '#fff', borderRadius: 8, position: 'relative', boxShadow: '0px 0px 50px #10101050' }}>
                    <div className="w-100 bg-gray-1 position-sticky top-0 flexcb" style={{ zIndex: 1, padding: '7px 20px', borderRadius: '8px 8px 0px 0px' }}>

                        <p className="text-semibig text-bold color-dark-blue-1">{translate("ca.Search Hubs")}</p>

                        <div className="flexc">

                            <LoaderButton
                                onClick={() => this.onDone()}
                                isLoading={this.state.isLoadingPost}
                                text={translate("ca.Done")}
                                backgroundImage='linear-gradient(45deg, #0094FF 0%, #6100FF 51%, #0094FF  100%)'
                                className={'button-interactive-1 py-1 px-2'}
                                language={this.props.language}
                            />

                        </div>

                    </div>

                    <div className="w-100 mb-0 px-4  py-1" style={{ backgroundColor: '#fff', borderBottom: '1px solid #eee' }}>
                        <input onChange={(e) => this.search(e.target.value)} placeholder={translate("ca.Search")} className="w-100" style={{ height: 30, fontSize: 15, background: 'transparent', borderRadius: 6, border: '0px solid #eee' }} />
                    </div>

                    <div className="w-100 text-start " >
                        {this.state.data.map((prop, index) => {
                            let selected = (this.state.selecteds[prop._id] && this.state.selecteds[prop._id].removed != true)
                            let disabled = this.state.selecteds[prop._id]?.disabled
                            return (
                                <div key={index} onClick={() => this.changeSelect(prop)} className="flexcb backHover pld-3 prd-4 pb-2 pt-2 cursor-pointer transition-all" style={{ borderLeft: selected ? (disabled ? '5px solid #aaa ' : '5px solid #1379ff ') : null, borderBottom: '0px solid ' + (selected ? (disabled ? '#f2f2f2' : '#e0e0ef60') : '#f6f6f6'), backgroundColor: (selected ? (disabled ? '#f2f2f2' : '#1379ff10 ') : 'transparent') }}>
                                    <div className='flexcc mrd-3'>
                                        <div>
                                            <img src={imageAddress(prop.image, 'profile', 'thumb')} width="36px" style={{ borderRadius: 50, height: 36, objectFit: 'cover' }} />
                                        </div>
                                        {/* <p className="mrd-3 mt-1" style={{ fontSize: 20 }} >{prop.flag}</p> */}
                                        <div className="px-2">
                                            {/* <p className="text-small mx-2">{prop.fullname}</p> */}
                                            <p className="text-small text-semibold  ">{prop.fullname}</p>

                                            {prop.username ? (
                                                <p className="text-smaller " style={{ color: '#789' }}>@{prop.username}</p>

                                            ) : (
                                                <p className="text-smaller " style={{ color: '#789' }}>{translate('ca.Virtual User')}</p>

                                            )}
                                            {/* <p className="text-smaller mx-2" style={{ color: '#789' }}>{prop.type}</p> */}
                                        </div>
                                    </div>

                                </div>
                            )
                        })}

                        {this.state.data?.length === 0 && (
                            <div className="text-center mt-5">
                                <img src="/images/target.svg" width="50px" />
                                <p className="text-center text-small text-bold">{translate('found-nothing')}</p>
                                <p className="text-center text-smaller">{translate('ca.Change your search options')}</p>

                            </div>
                        )}
                    </div>
                </div>
            </Modal >
        );

    }
}


export default SearchUsersModal;
